"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactPopper = require("react-popper");
var _Input = require("../../Input/Input");
var BaseInputTooltip = function BaseInputTooltip(props) {
  var _props$show = props.show,
    show = _props$show === void 0 ? false : _props$show,
    text = props.text,
    TooltipFooter = props.TooltipFooter,
    children = props.children;
  var referenceElement = _react["default"].useRef();
  var _React$useState = _react["default"].useState(),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    popperElement = _React$useState2[0],
    setPopperElement = _React$useState2[1];
  var _React$useState3 = _react["default"].useState(),
    _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
    arrowElement = _React$useState4[0],
    setArrowElement = _React$useState4[1];
  var _usePopper = (0, _reactPopper.usePopper)(referenceElement.current, popperElement, {
      placement: 'top',
      modifiers: [{
        name: 'arrow',
        options: {
          element: arrowElement
        }
      }, {
        name: 'offset',
        options: {
          offset: [0, 0]
        }
      }, {
        name: 'flip',
        enabled: false
      }]
    }),
    styles = _usePopper.styles,
    attributes = _usePopper.attributes;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledChildrenWrapper, {
    ref: function ref(_ref) {
      return referenceElement.current = _ref;
    }
  }, children), show ? /*#__PURE__*/_react["default"].createElement(StyledWrapper, (0, _extends2["default"])({
    ref: function ref(_ref3) {
      return setPopperElement(_ref3);
    },
    style: styles.popper
  }, attributes.popper), /*#__PURE__*/_react["default"].createElement("div", null, text), TooltipFooter, /*#__PURE__*/_react["default"].createElement(StyledArrow, {
    ref: function ref(_ref2) {
      return setArrowElement(_ref2);
    },
    style: styles.arrow
  })) : null);
};
var StyledChildrenWrapper = _styledComponents["default"].div.withConfig({
  displayName: "InputTooltip__StyledChildrenWrapper",
  componentId: "sc-cb4zv0-0"
})(["", "{border-top-right-radius:0;border-bottom-right-radius:0;border-right:none;}"], _Input.StyledInput);
var StyledArrow = _styledComponents["default"].div.withConfig({
  displayName: "InputTooltip__StyledArrow",
  componentId: "sc-cb4zv0-1"
})(["width:0;height:0;border-left:15px solid transparent;border-right:15px solid transparent;border-top:15px solid #fffbe8;margin-top:4px;"]);
var StyledWrapper = _styledComponents["default"].div.withConfig({
  displayName: "InputTooltip__StyledWrapper",
  componentId: "sc-cb4zv0-2"
})(["background-color:#fffbe8;padding:8px;border-radius:3px;vertical-align:middle;box-shadow:0 2px 20px 0 rgba(191,191,172,0.5);max-width:250px;"]);
var _default = exports["default"] = BaseInputTooltip;